import { FC, useState } from 'react';
import { ICountryDetail } from '../../../../../../types/countries';
import { NudosButton, NudosCityDropdown, NudosTextInput } from '../../../../../../components/NudosComponents';
import { IcityDetails } from '../../../../../../types/cities.types';
import CheckArrowIcon from '../../../../../../assets/images/catalogue/CheckArrowIcon';

import './CountryCard.scss';
import { createNewCity } from '../../../../../../services/opsSupport.service';
import { ICreateNewCity } from '../../../../../../types/OpsSupport';
import {
  displayErrorNotification,
  displaySuccessNotification
} from '../../../../../../utils/displayNudosStandardNotifications';

interface ICountryCard {
  countryData: ICountryDetail;
}

const CountryCard: FC<ICountryCard> = ({ countryData }: ICountryCard) => {
  const [selectCountry, setSelecCountry] = useState<boolean>(false);
  const [city, setCity] = useState<IcityDetails>();
  const [selectCreateNewCity, setSelectCreateNewCity] = useState<boolean>(false);
  const [newCityName, setNewCityName] = useState<string>();
  const [loadingButton, setLoadingButton] = useState<boolean>(false);

  const saveNewCity = async () => {
    if (newCityName) {
      setLoadingButton(true);
      const bodyNewCity: ICreateNewCity = {
        countryId: Number(countryData.id),
        name: newCityName
      };
      try {
        await createNewCity(bodyNewCity);
        setNewCityName(undefined);
        setSelectCreateNewCity(false);
        setCity(undefined);
        displaySuccessNotification({
          customJSXMessage: (
            <>
              Se creo la ciudad <strong>{newCityName}</strong> en el país<strong> {countryData.name}</strong>
            </>
          )
        });
      } catch (error) {
        displayErrorNotification();
      } finally {
        setLoadingButton(false);
      }
    }
  };

  return (
    <div id="countryCityCard">
      <div
        className={`countryCityCardCointainer ${selectCountry ? 'selectCard' : ''}`}
        style={{ cursor: !selectCountry ? 'pointer' : '' }}
        onClick={() => {
          setSelecCountry(true);
        }}
      >
        <div className="containerCountryName">
          <div className="flagContianer">
            <div
              className="flagStyleCity"
              style={{ backgroundImage: `url(${countryData.flag})`, opacity: !selectCountry ? 0.4 : '' }}
            ></div>
          </div>
          <div className={selectCountry ? 'selectCountry' : 'noCountrySelect'}>{countryData.name}</div>
        </div>
        <div className="cityComponentContainer">
          {loadingButton ? (
            <div className="animationLoader w-full rounded" style={{ height: '66px' }}></div>
          ) : (
            <NudosCityDropdown
              countryId={selectCountry && countryData?.id ? countryData.id : undefined}
              updateCurrentValueCallback={e => {
                setCity(e);
              }}
              currentValue={city}
              customCityLabel="Intenta buscar la ciudad antes de agregarla"
            />
          )}
        </div>
        <div
          className="selectNoExistCity"
          onClick={() => {
            if (selectCountry) {
              setSelectCreateNewCity(!selectCreateNewCity);
            }
          }}
        >
          <div className="checkContainer">
            {selectCreateNewCity ? (
              <div className="orangeMark">
                <CheckArrowIcon />
              </div>
            ) : (
              <div className="grayMark" />
            )}
          </div>
          <div className={`${selectCreateNewCity ? 'textCheck' : 'textNoCheck'}`}>Quiero crear una nueva ciudad</div>
        </div>
        <div className="newCityTextContainer">
          <NudosTextInput
            isDeactivated={!selectCreateNewCity}
            isFilled={!!newCityName}
            placeholder="Escribe el nombre de la nueva ciudad"
            handleChange={e => {
              setNewCityName(e);
            }}
          />
        </div>
        <div className="newCityButtonContainer">
          <NudosButton
            isButtonDisabled={!newCityName || !selectCreateNewCity}
            isButtonLoading={loadingButton}
            customHeight="30px"
            customWidth="100px"
            buttonText="Agregar Ciudad"
            handleClick={() => {
              saveNewCity();
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default CountryCard;
